import { toast } from "@/v2-ui/toast"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import type { InvitationFragment } from "@/v2-backoffice-client/invitation/__types__/invitation.fragment"
import {
  getSignupUrl,
  copyToClipboard,
} from "@/v2-backoffice-client/invitation/invitation.utils"

export type InvitationCopyMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  invitation: InvitationFragment
}

function InvitationCopyMenuItem(props: InvitationCopyMenuItemProps) {
  const { invitation, children, ...menuItemProps } = props

  return (
    <ActionMenu.Item
      iconSrc="copy"
      onSelect={(e) => {
        e.preventDefault()
        const url = getSignupUrl(invitation)
        copyToClipboard(url)
          .then(() => {
            toast({
              title: "Invitation link was copied to the clipboard",
            })
          })
          .catch((error) => {
            console.error("Failed to copy:", error)
          })
      }}
      {...menuItemProps}
    >
      {children ?? "Copy Signup Link"}
    </ActionMenu.Item>
  )
}

export default InvitationCopyMenuItem
